import 'owl.carousel';

export function carousel() {

    $(document).ready(function () {
        $("#partners-carousel").owlCarousel({
            loop: true,
			nav: true,
			smartSpeed: 2000,
            responsive: {
                0: {
                    items: 1,
					slideBy: 1,
					onDrag: dragCallback,
					smartSpeed: 300,
					mouseDrag: false
                },
                768: {
                    items: 2,
                    slideBy: 2,
                },
                1024: {
                    items: 3,
                    slideBy: 3,

                }
            }
        });

        $("#home-carousel").owlCarousel({
			items: 1,
			slideBy: 1,
            loop: true,
            nav: true,
            navText: ["",
                ""],
			dotsContainer: '#hc-dots',
            video: true,
			smartSpeed: 2000,
			autoHeight: false,
			responsive: {
				0: {
					onDrag: dragCallback,
					smartSpeed: 300,
					mouseDrag: false
				},
				768: {
				},
				1024: {
					items: 1,
					slideBy: 1,
					dotsContainer: '#hcd-dots'
				}
			}
		});

		$("#workCaseCarousel").owlCarousel({
			loop: true,
			nav: true,
			navContainer: '#work-cs-nav',
			dotsContainer: '#work-cs-dots',
			items: 1,
			lazyLoad: true,
			responsive: {
				0: {
					onDrag: dragCallback,
					smartSpeed: 300,
				},
				720: {
					smartSpeed: 2000,
				}
			}
		});

		$("#cs-carousel").owlCarousel({
			loop: true,
			nav: true,
			navContainer: '#brandNav-nav',
			dotsContainer: '#brandNav-dots',
			items: 1,
			lazyLoad: true,
			responsive: {
				0: {
					onDrag: dragCallback,
					smartSpeed: 300,
				},
				720: {
					smartSpeed: 2000,
				}
			}
		});

		$("#header-carousel").owlCarousel({
			loop: true,
			navContainer: '#headerNav',
			dotsContainer: '#headerDots',
			items: 1,
			lazyLoad: true,
			responsive: {
				0: {
					onDrag: dragCallback,
					smartSpeed: 300,
				},
				720: {
					smartSpeed: 2000
				}
			}
		}); 

		const carouselVars = $('#home-carousel, #workCaseCarousel, #cs-carousel, #header-carousel');

		carouselVars.on('change.owl.carousel', function () {
			checkCarouselThemeType();
		});

		$('.home-carousel-section').on('mousemove', function(e) {
			if ((e.pageX - this.offsetLeft) < $(this).width() / 2) {
				$("nav.prev").fadeIn();
				$("nav.next").fadeOut();
			} else {
				$("nav.next").fadeIn();
				$("nav.prev").fadeOut();
			}
		});

		$('.home-carousel-section').mouseleave(function () {
			$("nav.next").fadeOut();
			$("nav.prev").fadeOut();
		});

        $('.customNextBtn').click(function (e) {
            e.preventDefault();
            $(".owl-carousel").trigger('next.owl.carousel');
        });
        $('.customPrevBtn').click(function (e) {
            e.preventDefault();
            $(".owl-carousel").trigger('prev.owl.carousel');
        });

        $("#hc-nav .next").click(function () {
            $("#home-carousel").trigger('next.owl.carousel');
        });

        $("#hc-nav .prev").click(function () {
			$("#home-carousel").trigger('prev.owl.carousel');
		});


		function checkCarouselThemeType() {
			setTimeout(function () {
				$('.owl-item.active').children().hasClass('carouselDarkTheme')
					? $('.customNextBtn, .customPrevBtn, .hc-customNav').addClass('carouselDarkTheme')
					: $('.customNextBtn, .customPrevBtn, .hc-customNav').removeClass('carouselDarkTheme');
			}, 500);
		}

		function dragCallback(e: any) {
			e.preventDefault();
			const direction = e.relatedTarget['_drag']['direction'];
			direction == 'left'
				? $('customNextBtn').click()
				: $('customPrevBtn').click()
		}


		/**
		 * 04/07/2019
		 * https://stackoverflow.com/a/24663217
		 * This jquery function below is a hacky way of getting around a known iOS issue. Currently on iOS devices, if you have an element with a state attached
		 * (hover, etc). Then iOS will fire the state event before the click event, meaning you have to press twice to use a link. There are also parent-sibling hierarchy
		 * ways that iOS breaks and pseudo-elements.
		**/
		$("#home-carousel a").on("touchend", function () {
			window.location.href = $(this).attr("href");
		});
    });
}
